import { createContext, useContext, useState, ReactNode } from 'react';

type WorkflowDebugCtxProps = { open: boolean; toggle: () => void };

const WorkflowDebugCtx = createContext<WorkflowDebugCtxProps | undefined>(undefined);

export const WorkflowDebugProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  return (
    <WorkflowDebugCtx.Provider value={{ open, toggle: () => setOpen((v) => !v) }}>
      {children}
    </WorkflowDebugCtx.Provider>
  );
};

export const useWorkflowDebug = () => useContext(WorkflowDebugCtx);
